// extracted by mini-css-extract-plugin
export default {"notification":"NotificationCard_notification__guwpt","notificationDate":"NotificationCard_notificationDate__roCp0"};